import { render, staticRenderFns } from "./FormsAndSurvey.vue?vue&type=template&id=4dd06d68&scoped=true&"
import script from "./FormsAndSurvey.vue?vue&type=script&lang=ts&"
export * from "./FormsAndSurvey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd06d68",
  null
  
)

export default component.exports